import { ErrorType } from '../../models/HttpError';
import { AppThunkAction } from '../reducers';
import * as actions from '../actions/ContractConceptRelationship.Actions';
import * as service from '../../services/ContractConceptRelationShip.Service';
import { ContractConceptRelationship, CreateContractConceptRelationship } from '../../models/Entities/Contracts/ContractConceptRelationship';


export type KnownActions = 
| actions.ContractConceptRelCreateFailureAction
| actions.ContractConceptRelCreateRequestAction
| actions.ContractConceptRelCreateSuccessAction
| actions.ContractConceptRelGetAllFailureAction
| actions.ContractConceptRelGetAllRequestAction
| actions.ContractConceptRelGetAllSuccessAction
| actions.ContractConceptRelUpdateFailureAction
| actions.ContractConceptRelUpdateRequestAction
| actions.ContractConceptRelUpdateSuccessAction
| actions.ContractConceptRelDeleteFailureAction
| actions.ContractConceptRelDeleteRequestAction
| actions.ContractConceptRelDeleteSuccessAction;


export const getAllContractConceptRelationships = (contractId: number, formConcept?: string): AppThunkAction<KnownActions> => async (dispatch, getState) => {
         
  var state = getState();
  var token: string;

  if (state.oidc?.user?.access_token === undefined) {
      dispatch({
          type: 'CONTRACT_CONCEPT_REL_GET_ALL_FAILURE',
          error: {
              ErrorCode: 401,
              ErrorMessage: 'Not authorized',
              Errors: []
          }
      });
      return;
  } else {
    token = state.oidc.user.access_token;
  }

  dispatch({
          type: 'CONTRACT_CONCEPT_REL_GET_ALL_REQUEST',
          contractId: contractId
      });
      service.getAllContractConceptFormRelationships(contractId, token, formConcept)
      .then((result: ContractConceptRelationship[]) => {
          dispatch({
                  type: 'CONTRACT_CONCEPT_REL_GET_ALL_SUCCESS',
                  items: result || [],
              });
      })
      .catch((error: ErrorType) =>
          dispatch({
              type: 'CONTRACT_CONCEPT_REL_GET_ALL_FAILURE',
              error: error
          })
      );
};

export const createContractConceptRelationship = (contractId: number, relationship: CreateContractConceptRelationship): AppThunkAction<KnownActions> => async (dispatch, getState) => {
  var state = getState();
  var token: string;

  if (state.oidc?.user?.access_token === undefined) {
      dispatch({
          type: 'CONTRACT_CONCEPT_REL_CREATE_FAILURE',
          error: {
              ErrorCode: 401,
              ErrorMessage: 'Not authorized',
              Errors: []
          }
      });
      return;
  } else {
    token = state.oidc.user.access_token;
  }


  dispatch({
      type: 'CONTRACT_CONCEPT_REL_CREATE_REQUEST',
      data: relationship
  });

  service.createContractConceptFormRelationship(contractId, relationship, token)
      .then((result) => {
          console.log(result);
          dispatch({
                  type: 'CONTRACT_CONCEPT_REL_CREATE_SUCCESS',
                  relationShip: result
              });
      })
      .catch((error: ErrorType) =>
          dispatch({
              type: 'CONTRACT_CONCEPT_REL_CREATE_FAILURE',
              error: error
          })
      );
};

export const updateContractConceptRelationship = (relationship: ContractConceptRelationship): AppThunkAction<KnownActions> => async (dispatch, getState) => {
  var state = getState();
  var token: string;
  if (state.oidc?.user?.access_token === undefined) {
      dispatch({
          type: 'CONTRACT_CONCEPT_REL_UPDATE_FAILURE',
          error: {
              ErrorCode: 401,
              ErrorMessage: 'Not authorized',
              Errors: []
          }
      });
      return;
  } else {
    token = state.oidc.user.access_token;
  }
  dispatch({
      type: 'CONTRACT_CONCEPT_REL_UPDATE_REQUEST',
      data: relationship
  });
  service.updateContractConceptFormRelationship(relationship.id, relationship, token)
      .then((result) => {
          console.log('respuesta', result);
          dispatch({
              type: 'CONTRACT_CONCEPT_REL_UPDATE_SUCCESS',
              relationship: result
          });
      })
      .catch((error: ErrorType) =>
          dispatch({
              type: 'CONTRACT_CONCEPT_REL_UPDATE_FAILURE',
              error: error
          })
      );
}

export const deleteContractConceptRelationship = (id: number): AppThunkAction<KnownActions> => async (dispatch, getState) => {
  var state = getState();
  var token: string;
  if (state.oidc?.user?.access_token === undefined) {
      dispatch({
          type: 'CONTRACT_CONCEPT_REL_DELETE_FAILURE',
          error: {
              ErrorCode: 401,
              ErrorMessage: 'Not authorized',
              Errors: []
          }
      });
      return;
  } else {
    token = state.oidc.user.access_token;
  }
  dispatch({
      type: 'CONTRACT_CONCEPT_REL_DELETE_REQUEST',
      id: id  
  });
  service.deleteContractConceptFormRelationship(id, token)
      .then((result) => {
          dispatch({
              type: 'CONTRACT_CONCEPT_REL_DELETE_SUCCESS',
              id: result.data
          });
      })
      .catch((error: ErrorType) =>
          dispatch({
              type: 'CONTRACT_CONCEPT_REL_DELETE_FAILURE',
              error: error
          })
      );
}

export const actionCreators = {
  getAllContractConceptRelationships,
  createContractConceptRelationship,
  updateContractConceptRelationship,
  deleteContractConceptRelationship,
};